module.exports = __webpack_public_path__ + "static/background-6d2e49f014b99a383d3ad1f126ca9089.jpg";